import Component from '../core/Component'
import { scrollToElement } from '../services/Scroll'
import { CMS } from '../core/config'

export const MODAL_SELECTOR = '[data-rel="news-modal"], [data-rel="job-modal"]'
export const CONTROL_SELECTOR = '[data-ref="modalNext"], [data-ref="modalPrevious"]'
export const ANCHOR_SELECTOR = 'a[href*="#"]:not([href="#todo"]):not([data-ref])'

export default class Page extends Component {

    constructor(element) {
        super(element)

        this.isOpen = false
        this.currentModal = null
        this.popStateClose = false
        this.request = null
    }

    prepare() {
        if (CMS) {
            return
        }

        this.element.addEventListener('click', this.handleClick)
    }

    openModal(trigger) {
        const url = trigger.href
        const type = trigger.dataset.rel

        const modal = Component.getFromElement(type)

        if (modal) {
            modal.options.url = url
            modal.options.filterResponse = function(html) {
                const buffer = document.createElement('div')
                buffer.innerHTML = html
                const content = buffer.querySelector('[data-modal-content]')
                const data = {}
                if (content) {
                    data.content = content.outerHTML
                }

                const title = buffer.querySelector('[data-modal-title]')
                if (title) {
                    data.title = title.innerText
                }
                return data
            }

            this.currentModal = modal
            modal.open(trigger)
        }
    }

    handleClick = event => {
        if(!event.target.closest) { // Polyfill doesn't apply for svg elements, skip in IE
            return
        }

        if (event.defaultPrevented) {
            return
        }

        // modals
        const modalTarget = event.target.closest(MODAL_SELECTOR)
        if (modalTarget) {
            event.preventDefault()
            this.openModal(modalTarget)
        }

        // anchors
        const id = event.target.closest(ANCHOR_SELECTOR)?.href?.split('#')[1]

        if (!id) {
            return
        }

        const element = document.getElementById(id)

        if (!element) {
            return
        }

        event.preventDefault()

        if (element.matches('.Section:not(.Section--appended):not(.Section--bare)')) {
            scrollToElement(element, {
                offset: 0
            })
        } else {
            scrollToElement(element)
        }

    }

}
